/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AdminService } from './services/AdminService';
import { AiReportsService } from './services/AiReportsService';
import { BulkDataService } from './services/BulkDataService';
import { ComputerVisionService } from './services/ComputerVisionService';
import { DataPipelineManualFixesService } from './services/DataPipelineManualFixesService';
import { DatasetService } from './services/DatasetService';
import { EmailService } from './services/EmailService';
import { ExportService } from './services/ExportService';
import { GroupService } from './services/GroupService';
import { GroupUserService } from './services/GroupUserService';
import { InternalService } from './services/InternalService';
import { MarketService } from './services/MarketService';
import { MarketAnalyticsService } from './services/MarketAnalyticsService';
import { PointsOfInterestService } from './services/PointsOfInterestService';
import { PropertyService } from './services/PropertyService';
import { PropertyReportService } from './services/PropertyReportService';
import { RentrollService } from './services/RentrollService';
import { SlackService } from './services/SlackService';
import { StripeService } from './services/StripeService';
import { TaskService } from './services/TaskService';
import { TemplaterService } from './services/TemplaterService';
import { UserService } from './services/UserService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class CoreClient {
    public readonly admin: AdminService;
    public readonly aiReports: AiReportsService;
    public readonly bulkData: BulkDataService;
    public readonly computerVision: ComputerVisionService;
    public readonly dataPipelineManualFixes: DataPipelineManualFixesService;
    public readonly dataset: DatasetService;
    public readonly email: EmailService;
    public readonly export: ExportService;
    public readonly group: GroupService;
    public readonly groupUser: GroupUserService;
    public readonly internal: InternalService;
    public readonly market: MarketService;
    public readonly marketAnalytics: MarketAnalyticsService;
    public readonly pointsOfInterest: PointsOfInterestService;
    public readonly property: PropertyService;
    public readonly propertyReport: PropertyReportService;
    public readonly rentroll: RentrollService;
    public readonly slack: SlackService;
    public readonly stripe: StripeService;
    public readonly task: TaskService;
    public readonly templater: TemplaterService;
    public readonly user: UserService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'https://api.hellodata.ai',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.admin = new AdminService(this.request);
        this.aiReports = new AiReportsService(this.request);
        this.bulkData = new BulkDataService(this.request);
        this.computerVision = new ComputerVisionService(this.request);
        this.dataPipelineManualFixes = new DataPipelineManualFixesService(this.request);
        this.dataset = new DatasetService(this.request);
        this.email = new EmailService(this.request);
        this.export = new ExportService(this.request);
        this.group = new GroupService(this.request);
        this.groupUser = new GroupUserService(this.request);
        this.internal = new InternalService(this.request);
        this.market = new MarketService(this.request);
        this.marketAnalytics = new MarketAnalyticsService(this.request);
        this.pointsOfInterest = new PointsOfInterestService(this.request);
        this.property = new PropertyService(this.request);
        this.propertyReport = new PropertyReportService(this.request);
        this.rentroll = new RentrollService(this.request);
        this.slack = new SlackService(this.request);
        this.stripe = new StripeService(this.request);
        this.task = new TaskService(this.request);
        this.templater = new TemplaterService(this.request);
        this.user = new UserService(this.request);
    }
}

